"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Widths_1 = __importDefault(require("../entity/FacetParts/Widths"));
const defaultValue = [
    { value: '980', count: 123 },
    { value: '1080', count: 1234 },
    { value: '1200', count: 1234 },
    { value: '1920', count: 1234 },
];
exports.generateWidthEntity = (jsons = defaultValue) => Widths_1.default.fromJSON({
    buckets: jsons,
});
